import React from "react";
import map from "../../assets/images/icons/map.svg";
import phone from "../../assets/images/icons/phone.svg";
import email from "../../assets/images/icons/email.svg";

const ContactBody = () => {
  return (
    <section className="section section-spacing-100">
      <div className="large">
        <div className="section-content width-960 margin-auto">
          <div className="contacts-container flex">
            <div className="contact-item">
              <div className="contact-item-head flex">
                <img src={map} alt="Map" /> <h2>Address</h2>
              </div>
              <div className="contact-item-body">
                <p>Kiwatule-Mbogo Road, Kampala</p>
                <p>At Nexus Lounge</p>
              </div>
            </div>
            <div className="contact-item">
              <div className="contact-item-head flex">
                <img src={email} alt="Email" /> <h2>Email</h2>
              </div>
              <div className="contact-item-body">
                <p>info@nexuseventsug.com</p>
                <p>sales@nexuseventsug.com</p>
              </div>
            </div>
            <div className="contact-item">
              <div className="contact-item-head flex">
                <img src={phone} alt="Phone" /> <h2>Phone Numbers</h2>
              </div>
              <div className="contact-item-body">
                <p>+256 (787) 258 151</p>
                <p>+256 (393) 810 810</p>
              </div>
            </div>
          </div>
          <div className="map-container width-100 section-spacing-50">
            <iframe
              src="https://www.google.com/maps/embed?pb=!1m12!1m8!1m3!1d63836.24656406374!2d32.5643878!3d0.2950739!3m2!1i1024!2i768!4f13.1!2m1!1snexus%20events!5e0!3m2!1sen!2sug!4v1741927742285!5m2!1sen!2sug"
              style={{ border: 0 }}
              allowfullscreen="true"
              loading="lazy"
              referrerpolicy="no-referrer-when-downgrade"
            ></iframe>
          </div>
          <div className="address-message flex justify-center">
            <a
              href="mailto:info@nexuseventsug.com"
              className="button dark-bg padding-16 white boldTitle"
            >
              Write To Us!
            </a>
          </div>
        </div>
      </div>
    </section>
  );
};

export default ContactBody;
